/**
 * Resolve a single balance from a profile `balances` map (exact key, then case-insensitive).
 * Used by embedder UI API so parents only receive the currency they asked for.
 */
export function pickProfileBalanceForCurrency(
  balances: Record<string, number>,
  requested: string
): { key: string; amount: number; hasEntry: boolean } {
  const t = requested.trim();
  if (!t) {
    return { key: '', amount: 0, hasEntry: false };
  }
  if (Object.prototype.hasOwnProperty.call(balances, t)) {
    const amount = balances[t];
    return { key: t, amount: typeof amount === 'number' && Number.isFinite(amount) ? amount : 0, hasEntry: true };
  }
  const lower = t.toLowerCase();
  for (const k of Object.keys(balances)) {
    if (k.toLowerCase() === lower) {
      const amount = balances[k];
      return { key: k, amount: typeof amount === 'number' && Number.isFinite(amount) ? amount : 0, hasEntry: true };
    }
  }
  return { key: t, amount: 0, hasEntry: false };
}
